export default "__VITE_ASSET__BThFmXIG__"